module.exports = __webpack_public_path__ + "img/p-one-step-01.a5d41fe0.png";